<template>
  <div class="inforPerfection">
     <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>
    <div class="setNavBg">
      <v-header :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"></v-header>
    </div>
    <v-publicBanner :bannerInfo="bannerInfo"></v-publicBanner>
    <div class="inforPerfectionCon">
      <el-form :model="baseInforRuleForm" :rules="baseInforRules" ref="perfectionForm" label-width="140px" class="demo-ruleForm">
        <div class="inforPerfectionTop">
          <div class="inforPerfectionTit"><h4>基本信息</h4></div>
          <div class="baseInforCon">
              <el-form-item label="企业身份" prop="orgIdentity">
                <el-checkbox v-model="baseInforRuleForm.orgIdentityCheckS" label="10" @change="checkSupplier" disabled>供应商</el-checkbox>
                <el-checkbox v-model="baseInforRuleForm.orgIdentityCheckP" label="20" @change="checkPurchaser" disabled>采购商</el-checkbox>
              </el-form-item>
              <!-- <el-form-item label="企业名称" prop="orgName" >
                <el-input v-model="baseInforRuleForm.orgName" class="pull-left" :disabled="companyDiabledFlag"></el-input>
                <el-button @click="findCompanyInfo()">获取最新工商信息</el-button>
              </el-form-item> -->
              <el-form-item label="企业名称" prop="orgName" class="businessName clearfix">
                <el-input maxlength = "50" v-model="baseInforRuleForm.orgName" @keyup.enter.native="loadCompanys" @change="updateButton()" placeholder="请输入企业名称后，点击'搜索'选择企业"></el-input>
                <transition name="el-zoom-in-top">
                  <div v-show="companyListShow" class="baseList">
                    <el-radio-group v-model="selectCompanyName" @change="selectCompany">
                      <el-radio v-for="(item,index) in companyData" :key="index" :label="item.name">{{item.name}}</el-radio>
                    </el-radio-group>
                  </div>
                </transition>
                <el-button  @click="loadCompanys" v-if="showButtonFlag == false">搜索</el-button>
                <el-button  @click="selectCompanyExt" v-if="showButtonFlag == true">获取最新工商信息</el-button>
            </el-form-item>
              <el-form-item label="法人代表" prop="orgHead">
                <el-input v-model="baseInforRuleForm.orgHead" minlength='2' maxlength='200'></el-input>
              </el-form-item>
              <el-form-item label="注册资金" prop="regFund" class="capital">
                <el-input v-model="baseInforRuleForm.regFund" maxlength="30"></el-input>
                <el-select v-model="baseInforRuleForm.regFundCurrency" placeholder="请选择币种">
                  <el-option label="RMB" value="10"></el-option>
                  <el-option label="USD" value="20"></el-option>
                  <el-option label="EUR" value="30"></el-option>
                  <el-option label="HKD" value="40"></el-option>
                  <el-option label="AUD" value="50"></el-option>
                  <el-option label="JPY" value="60"></el-option>
                  <el-option label="GBP" value="70"></el-option>
                  <el-option label="SGD" value="80"></el-option>
                  <el-option label="CHF" value="90"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="成立时间" prop="foundDate">
                <el-date-picker
                  v-model="baseInforRuleForm.foundDate"
                  type="date"
                  placeholder="选择日期"
                  @change="changeFoundDate">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="营业期限" prop="businessBeginTime" class="businessTerm">
                <el-date-picker
                  v-model="baseInforRuleForm.businessBeginTime"
                  type="date"
                  placeholder="选择日期"
                  @change="changeBussinessDate">
                </el-date-picker>
                <el-date-picker
                  v-model="baseInforRuleForm.businessEndTime"
                   type="date"
                  placeholder="选择日期" v-if="businessEndTimeShowFlag"
                  @change="changeBussinessDate">
                </el-date-picker>
                <el-checkbox v-model="baseInforRuleForm.validTime" @change="changeValidTime">营业期限长期有效</el-checkbox>
              </el-form-item>
              <el-form-item label="注册地址" prop="regAddrDetail" class="address">
                <div>
                <el-select v-model="baseInforRuleForm.regAddrCountry" placeholder="请选择国家" @change="selectCountry">
                  <el-option v-for="item in countries"
                      :key="item.countryCode"
                      :label="item.countryName"
                      :value="item.countryCode">
                  </el-option>
                </el-select>
                </div>
                <el-select v-model="baseInforRuleForm.regAddrProvince" placeholder="请选择省份" @change="selectProvince" v-if="addressFlag">
                  <el-option v-for="item in provinces"
                      :key="item.provinceCode"
                      :label="item.provinceName"
                      :value="item.provinceCode">
                  </el-option>
                </el-select>
                <el-select v-model="baseInforRuleForm.regAddrCity" placeholder="请选择城市" @change="selectCity" v-if="addressFlag">
                  <el-option v-for="item in cities"
                      :key="item.cityCode"
                      :label="item.cityName"
                      :value="item.cityCode">
                  </el-option>
                </el-select>
                <el-input v-model="baseInforRuleForm.regAddrDetail" maxlength="500" placeholder="请输入公司的注册地址" style="display:block;"></el-input>
              </el-form-item>
              <el-form-item label="所属行业" prop="industryShowContent" class="selectCon">
                <el-input v-model="baseInforRuleForm.industryShowContent" v-if="false"></el-input>
                <el-tag v-for="tag in industryDatas" :key="tag.id" closable  @close="removeIndustry(tag.industryName,tag.id)"> {{tag.industryName}}
                </el-tag>
                <el-button @click="openIndutry()">选择</el-button>
              </el-form-item>
              <el-form-item label="主要产品/服务" prop="serviceShowContent" class="selectCon">
                <el-tag v-for="tag in serviceDatas" :key="tag.id"  closable @close="removeService(tag.serviceName,tag.id)"> {{tag.serviceName}}
                </el-tag>
                <el-input v-model="baseInforRuleForm.serviceShowContent" v-if="false"></el-input>
                <el-button @click="openService()">选择</el-button>
                <p class="el-upload__tip" style="line-height: 1.5;">您最多可选择20个分类，准确的选择您企业提供的产品与服务分类，更有利于您企业获取精准商机</p>
              </el-form-item>
              <el-form-item label="主营业务" prop="businessScope">
                <el-input type="textarea" maxlength="2000" v-model="baseInforRuleForm.businessScope" placeholder="请输入2000字以内的营业范围"></el-input>
              </el-form-item>

          </div>
        </div>
        <div class="inforPerfectionBottom">
          <div class="inforPerfectionTit"><h4>三证信息</h4></div>
          <div class="cardInforCon">
            <!-- <el-form-item label="境内外供应商" prop="regAddrType" >
              <el-radio-group v-model="baseInforRuleForm.regAddrType" :disabled="disabledAddressFlag">
                <el-radio label="0">境内</el-radio>
                <el-radio label="1">境外</el-radio>
              </el-radio-group>
            </el-form-item> -->
            <el-form-item label="是否三证合一" prop="isThreeToOne" v-if="showFlag">
              <el-radio-group v-model="baseInforRuleForm.isThreeToOne" @change="selectThreeToOne">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="regeistFileName" prop="threeLicenceCode" v-if="threeFlag" style="margin-bottom: 8px" ref="threeLicenceCodeExt">
              <el-input v-model="baseInforRuleForm.threeLicenceCode" style="margin-bottom: 16px"  :maxlength="100"></el-input>
              <div class="control-con">
                <div class="upBtn">
                  <input type="file" id="threeLienceCodeInputFile" name="threeLicenceCodeFile" ref="threeLicenceCodeFile" @change="tirggerThreeLienceCodeFile($event)" >
                  <input class="btn btn-default" type="button" value="上传附件" >
                </div>
                <a href="#"  class="filesList" @click="viewAttachment(baseInforRuleForm.threeLicenceCodeFileUrl)" v-if="showThreeLienceFlag">{{baseInforRuleForm.threeLicenceCodeFileName}}</a><a href="JavaScript:void(0)" @click="deleteThreeLienceCodeFile()" v-if="showThreeLienceFlag">删除</a>
              </div>
            </el-form-item>
            <el-form-item label="" v-if="threeFlag" style="margin-bottom: 32px">
              <div class="el-upload__tip">
                  <!--<p>1. 请上传<span>加盖企业红色公章</span>的营业执照（<span>正本</span>）复印件；</p>-->
                  <!--<p>2. 请确保您注册的<span>企业名称与企业营业执照上的名称一致</span>；</p>-->
                  <!--<p>3. 扫描件支持JPG,PNG,BMP,PDF格式，文件最大不超过10M；</p>-->
                <p>请上传营业执照<span>加盖公章</span>，上传文件不得超过10M</p>
              </div>
            </el-form-item>
            <el-form-item label="营业执照代码" prop="licenceCode" v-if="!threeFlag"  style="margin-bottom: 8px">
              <el-input v-model="baseInforRuleForm.licenceCode" style="margin-bottom: 16px" :maxlength="100"></el-input>
                <div class="control-con">
                  <div class="upBtn">
                    <input type="file" id="lienceCodeFile" name="licenceCodeFile" ref="licenceCodeFile" @change="tirggerLienceCodeFile($event)" >
                    <input class="btn btn-default" type="button" value="上传附件" >
                  </div>
                  <a href="#" class="filesList" @click="viewAttachment(baseInforRuleForm.licenceCodeFileUrl)" v-if="showLienceFlag">{{baseInforRuleForm.licenceCodeFileName}}</a><a href="JavaScript:void(0)" @click="deleteLienceCodeFile()" v-if="showLienceFlag">{{deleteLicTxt}}</a>
                </div>
            </el-form-item>
            <el-form-item label="" v-if="!threeFlag" style="margin-bottom: 32px">
              <div class="el-upload__tip">
                  <!--<p>1. 请上传<span>加盖企业红色公章</span>的营业执照（<span>正本</span>）复印件；</p>-->
                  <!--<p>2. 请确保您注册的<span>企业名称与企业营业执照上的名称一致</span>；</p>-->
                  <!--<p>3. 扫描件支持JPG,PNG,BMP,PDF格式，文件最大不超过10M；</p>-->
                <p>请上传营业执照<span>加盖公章</span>，上传文件不得超过10M</p>
              </div>
            </el-form-item>
            <el-form-item label="组织结构代码" prop="organizationCode" v-if="!threeFlag" style="margin-bottom: 8px">
              <el-input v-model="baseInforRuleForm.organizationCode" style="margin-bottom: 16px" :maxlength="100"></el-input>
                <div class="control-con">
                  <div class="upBtn">
                    <input type="file" id="organizationCodeFile" name="organizationCodeFile"  ref="organizationCodeFile" @change="tirggerOrganizationCodeFile($event)" >
                    <input class="btn btn-default" type="button" value="上传附件" >
                  </div>
                  <a href="#" class="filesList" @click="viewAttachment(baseInforRuleForm.organizationCodeFileUrl)" v-if="showOrganizationFlag">{{baseInforRuleForm.organizationCodeFileName}}</a><a href="JavaScript:void(0)" @click="deleteOrganizationCodeFile()" v-if="showOrganizationFlag">{{deleteOrgTxt}}</a>
                </div>
            </el-form-item>
            <el-form-item label="" v-if="!threeFlag" style="margin-bottom: 32px">
                <div class="el-upload__tip">
                  <!--<p>1. 请上传<span>加盖企业红色公章</span>的组织机构代码证（<span>正本</span>）复印件；</p>-->
                  <!--<p>2. 扫描件支持JPG,PNG,BMP,PDF格式，文件最大不超过10M；</p>-->
                  <p>请上传组织机构代码证<span>加盖公章</span>，上传文件不得超过10M</p>
                </div>
            </el-form-item>
            <el-form-item label="税务登记证" prop="taxCode" v-if="!threeFlag" style="margin-bottom: 8px">

              <el-input v-model="baseInforRuleForm.taxCode" style="margin-bottom: 16px" :maxlength="100"></el-input>
                <div class="control-con">
                  <div class="upBtn">
                    <input type="file" id="taxCodeFile" name="taxCodeFile" ref="taxCodeFile"  @change="tirggerTaxCodeFile($event)" >
                    <input class="btn btn-default" type="button" value="上传附件" >
                  </div>
                  <a href="#" class="filesList" @click="viewAttachment(baseInforRuleForm.taxCodeFileUrl)" v-if="showTaxFlag">{{baseInforRuleForm.taxCodeFileName}}</a><a href="JavaScript:void(0)" @click="deleteTaxCodeFile()" v-if="showTaxFlag">{{deleteTaxTxt}}</a>
                </div>
            </el-form-item>
            <div v-if="!threeFlag" style="margin:15px 0 32px 140px;">
                <div class="el-upload__tip">
                  <!--<p>1. 扫描件支持JPG,PNG,BMP,PDF格式，文件最大不超过10M；</p>-->
                  <p style="color: #A8ACB2;">请上传税务登记证<span style="color: #CF2727;">加盖公章</span>，上传文件不得超过10M</p>
                </div>
            </div>
            <el-form-item label="工商变更证明" prop="bussinessChangeFileUrl" style="margin-bottom: 8px">
              <!--<div class="downCon">-->
                <!--<el-button @click="viewAttachment(authorizationUrl)">下载工商变更证明</el-button>-->
              <!--</div>-->
              <div class="control-con">
                  <div class="upBtn">
                    <input type="file" id="bussinessChangeFile" name="bussinessChangeFile" ref="bussinessChangeFile"   @change="tirggerBussinessChangeFile($event)" >
                    <input class="btn btn-default" type="button" value="上传附件" >
                  </div>
                  <a href="#" class="filesList" @click="viewAttachment(baseInforRuleForm.bussinessChangeFileUrl)" v-if="showBussinessFlag">{{baseInforRuleForm.bussinessChangeFileName}}</a><a href="JavaScript:void(0)" @click="deleteBussinessChangeFile()" v-if="showBussinessFlag">删除</a>
                </div>
            </el-form-item>
            <el-form-item label="" style="margin-bottom: 32px">
                <div class="el-upload__tip">
                  <!--<p>1. 请上传<span>加盖企业红色公章</span>的工商变更证明（<span>正本</span>）复印件；</p>-->
                  <!--<p>2. 扫描件支持JPG，PNG，BMP，PDF格式，文件最大不超过10M；</p>-->
                  <p>请上传工商变更证明<span>加盖公章</span>，上传文件不得超过10M</p>
                </div>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div class="inforBtnCon">
        <el-row>
          <el-button type="primary" @click="submitForm('perfectionForm')" :disabled="!editFlag">提交申请</el-button>
          <el-button type="primary" @click="redirectGroup()" :disabled="editFlag">下一步</el-button>
        </el-row>
      </div>
    </div>
    <v-footer :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos'></v-footer>

    <div>
        <el-dialog title="选择所属行业" :visible.sync="industryShowFlag" custom-class="serviceDia">
          <div>选择所属行业：<el-input placeholder="输入关键字进行过滤"  v-loading="loading" :maxlength="100" v-model="filterIndustryKey" style="width:400px"> </el-input> <span v-if="filterIndustryFlag">符合条件的共{{this.filterIndustryNumber}}条</span> </div>
          <div class="serviceTree">
          <el-tree :data="industryTree" ref="tree2" class="filter-tree"  show-checkbox node-key="id" 	 :filter-node-method="filterIndustry"  :props="defaultIndustryProps" @check-change="handleCheckIndustryChange" @selection-change="changeIndustry">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span v-html="node.label"></span>
            </span>
          </el-tree>
          </div>
          <span slot="footer" class="dialog-footer">
              <el-button size="small" type="primary" @click="prewIndustry()">确 定</el-button>
              <el-button size="small" @click="closeIndustry()">取 消</el-button>
          </span>
        </el-dialog>
    </div>

    <div>
        <el-dialog title="选择主要产品/服务" :visible.sync="serviceShowFlag" custom-class="serviceDia">
         <div>选择主要产品/服务：<el-input placeholder="输入关键字进行过滤"  v-loading="loading" :maxlength="100" v-model="filterServiceKey" style="width:400px"> </el-input> <span v-if="filterServiceFlag">符合条件的共{{this.filterServiceNumber}}条</span> </div>
          <div class="serviceTree">
          <el-tree :data="serviceTree" ref="tree3" show-checkbox node-key="id" 	 :filter-node-method="filterSerivce"   :props="defaultServiceProps" @check-change="handleCheckServiceChange" @selection-change="changeService">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span v-html="node.label"></span>
            </span>
          </el-tree>
          </div>
          <span slot="footer" class="dialog-footer">
              <el-button size="small" type="primary" @click="prewService()">确 定</el-button>
              <el-button size="small" @click="closeService()">取 消</el-button>
          </span>
        </el-dialog>
    </div>
    <v-backToTop></v-backToTop>
  </div>

</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import publicBanner from '@/components/publicBanner'
  import footer from '@/components/v-footer'
  import backToTop from '@/components/backToTop'
  import { mapState } from 'vuex'

  export default {
    props: [],
    data () {
      var checkFoundDate = (rule, value, callback) => {
        if (value!='') {
          this.foundDate = this.baseInforRuleForm.foundDate;
          if(this.foundDate == null || this.foundDate == ''){
            this.foundDateCount = 0;
          }else{
            this.foundDateCount = new Date(this.transferDate(this.foundDate.getTime())).getTime();
          }
          if(this.baseInforRuleForm.businessBeginTime != null && this.baseInforRuleForm.businessBeginTime !=''){
            if(new Date(this.transferDate(this.baseInforRuleForm.businessBeginTime.getTime())).getTime()<this.foundDateCount){
              return callback(new Error('营业期限开始时间不能早于成立时间,请重新填写'));
            }else{
              return callback();
            }
          }else{
            return callback();
          }

        }else{
          return callback(new Error('请输入成立时间'));
        }
      }
      var checkBussinessBeginime = (rule, value, callback) => {
        if (value!='') {
          this.businessEndTime = this.baseInforRuleForm.businessEndTime;
          this.foundDate = this.baseInforRuleForm.foundDate;

          if(this.businessEndTime == null || this.businessEndTime == ''){
            this.businessEndTimeCount = 0;
          }else{
            this.businessEndTimeCount = new Date(this.transferDate(this.businessEndTime.getTime())).getTime();
          }
          if(this.foundDate == null || this.foundDate == ''){
            this.foundDateCount = 0;
          }else{
            this.foundDateCount = new Date(this.transferDate(this.foundDate.getTime())).getTime();
          }


          if(!this.baseInforRuleForm.validTime && this.baseInforRuleForm.businessBeginTime.getTime()>this.businessEndTimeCount){
            this.checkBusinessBeginTimeFlag = false;
            return callback(new Error('您填写的营业期限有误,结束时间应大于开始时间,请重新填写'));
          }else if(!this.baseInforRuleForm.validTime && this.baseInforRuleForm.businessBeginTime.getTime()==this.businessEndTimeCount){
            this.checkBusinessBeginTimeFlag = false;
            return callback(new Error('您填写的营业期限有误,结束时间不能等于开始时间,请重新填写'));
          }else if(new Date(this.transferDate(this.baseInforRuleForm.businessBeginTime.getTime())).getTime()<this.foundDateCount){
            this.checkBusinessBeginTimeFlag = false;
            return callback(new Error('营业期限开始时间不能早于成立时间,请重新填写'));
          }else if(new Date(this.baseInforRuleForm.businessBeginTime) == null && !this.baseInforRuleForm.validTime ){
            this.checkBusinessBeginTimeFlag = false;
            return callback(new Error('请输入营业结束时间'));
          }else{
            this.checkBusinessBeginTimeFlag = true;
            return callback();
          }
        }else{
          this.checkBusinessBeginTimeFlag = false;
          return callback(new Error('请输入营业开始时间'));
        }
      };
      var checkNumber = (rule, value, callback) => {
        var regNumber = /(^[1-9]([0-9]+)?(\.[0-9]{1,8})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
        if (!regNumber.test(value)) {
          return callback(new Error('注册资金格式不正确,最多支持30位数字其中小数最多8位'));
        }else{
          return callback();
        }
      };
      var checkThreeLienceCodeFile = (rule, value, callback) => {
        if (this.baseInforRuleForm.regAddrType == '1'&&this.baseInforRuleForm.threeLicenceCodeFileUrl == '') {
          return callback(new Error('请上传工商注册登记号附件'));
        }else  if(this.baseInforRuleForm.threeLicenceCodeFileUrl == ''){
          return callback(new Error('请上传营业执照附件'));
        } else{
          return callback();
        }
      };
      var checkThreeLienceCode = (rule, value, callback) => {
        if (this.baseInforRuleForm.regAddrType == '1' && value == '') {
          return callback(new Error('请输入商业登记注册号'));
        }else if (value == '') {
          return callback(new Error('请输入营业执照代码'));
        }else{
          return callback();
        }
      };
      var checkLicenceCodeFile = (rule, value, callback) => {
        if (this.baseInforRuleForm.licenceCodeFileUrl == '') {
          return callback(new Error('请上传营业执照附件'));
        }else{
          return callback();
        }
      };
      var checkOrganizationCodeFile = (rule, value, callback) => {
        if (this.baseInforRuleForm.organizationCodeFileUrl == '') {
          return callback(new Error('请上传组织机构附件'));
        }else{
          return callback();
        }
      };
      var checkTaxCodeFile = (rule, value, callback) => {
        if (this.baseInforRuleForm.taxCodeFileUrl == '') {
          return callback(new Error('请上传税务登记证附件'));
        }else{
          return callback();
        }
      };
      return {
        groupDetailUrl:'',
        editFlag:false,
        submitDisableFlag:true,
        confirmDisableFlag:false,
        showFlag:true,
        disabledAddressFlag:true,
        showButtonFlag:true,
        initOrgName:'',
        creditCompanyInfo:{},
        selectCompanyName:'',
        searchVagueCompany:'',
        companyListShow:false,
        companyData:[],
        selectCompanyId:'',
        companySearch:'',
        disabledFlag:true,
        deleteOrgTxt:'',
        deleteLicTxt:'',
        deleteThreeLicTxt:'',
        deleteTaxTxt:'',
        businessEndTimeShowFlag:true,
        checkBusinessBeginTimeFlag:true,
        foundDateCount:0,
        businessEndTimeCount:0,
        foundDate:null,
        businessEndTime:null,
        regeistFileName:'',
        companyDiabledFlag:false,
        regeistFileDisableFlag:false,
        threeShowflag:true,
        checkFlag:true,
        filterIndustryFlag:false,
        filterServiceFlag:false,
        filterIndustryNumber:0,
        filterServiceNumber:0,
        loading:false,
        filterIndustryKey:'',
        filterServiceKey:'',
        addressFlag:false,
        hitSearchUrl:'',
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{},
        navigationColumnInfos: [],
        industryTree:[],
        industryTreeStorage:[],
        serviceTree:[],
        serviceTreeStorage:[],
        industryShowFlag:false,
        serviceShowFlag:false,
        defaultCheckIndustryKey:[],
        multipleIndustrySelection:[],
        multipleServiceSelection:[],
        industryShowContent:'',
        serviceShowContent:'',
        threeFlag:true,
        showThreeLienceFlag:false,
        showLienceFlag:false,
        showOrganizationFlag:false,
        showTaxFlag:false,
        showBussinessFlag:false,
        countries:[],
        provinces:[],
        cities:[],
        bannerInfo: {title: '信息完善',content: "Information perfection"},
        webConfigInfo: {},
        footerColumnInfos:[],
        defaultIndustryProps: {
          label: 'industryName',
          children: 'children',
        },
        defaultServiceProps: {
          label: 'serviceName',
          children: 'children',
        },
        serviceData:{},
        serviceDatas:[],
        serviceExtDatas:[],
        industryData:{},
        industryDatas:[],
        industryExtDatas:[],
        baseInforRuleForm: {
          orgIdentityCheckS:true,
          orgIdentityCheckP:false,
          validTime:false,
          id:'',
          orgIdentity: '10',
          orgName: '',
          orgHead: '',
          regFund: '',
          regFundCurrency:'10',
          foundDate:'',
          businessBeginTime: '',
          businessEndTime:'',
          regAddrCountry: '86',
          regAddrProvince:'110000',
          regAddrCity:'110100',
          regAddrDetail:'',
          regAddrType:'0',
          isThreeToOne:'0',
          threeLicenceCodeFile:{},
          threeLicenceCode:'',
          threeLicenceCodeFileUrl:'',
          threeLicenceCodeFileName:'',
          threeLicenceCodeFileKey:'',
          licenceCodeFile:{},
          licenceCode:'',
          licenceCodeFileUrl:'',
          licenceCodeFileName:'',
          licenceCodeFileKey:'',
          organizationCodeFile:{},
          organizationCode:'',
          organizationCodeFileUrl:'',
          organizationCodeFileName:'',
          organizationCodeFileKey:'',
          taxCodeFile:{},
          taxCode:'',
          taxCodeFileUrl:'',
          taxCodeFileName:'',
          taxCodeFileKey:'',
          upfile:{},
          industriesDtos:[],
          serviceDtos:[],
          businessScope:'',
          industryShowContent:'',
          serviceShowContent:'',
          bussinessChangeFileUrl:'',
          bussinessChangeFileName:'',
          bussinessChangeFileKey:'',
          industriesDtos:[],
          serviceDtos:[],
          industriesExtDtos:[],
          serviceExtDtos:[],
          majorBussiness:'',
          industryShowContent:'',
          industryDatas:[],
          serviceShowContent:'',
          serviceDatas:[]
        },
        orgId:'',
        companyInfo:{},
        ucenterInfo:{},
        baseInforRules: {
          authFileUrl: [
            { required: true, message: '请选择企业授权函', trigger: 'blur' }
          ],
          orgName: [
            { required: true, message: '请输入企业名称', trigger: 'blur'}
          ],
          orgHead: [
            { required: true, message: '请输入法人代表', trigger: 'blur'}
          ],
          regFund: [
            { required: true, message: '请输入注册资金', trigger: 'blur'}
          ],
          businessBeginTime: [
            { required: true, message: '请输入营业开始时间', trigger: 'blur'}
          ],
          foundDate: [
            { required: true, message: '请输入成立时间', trigger: 'blur'},
            { validator: checkFoundDate, trigger: 'blur' }
          ],
          regAddrDetail: [
            { required: true, message: '请输入公司的注册地址', trigger: 'blur'}
          ],
          isThreeToOne: [
            { required: true, message: '请选择是否三证合一', trigger: 'blur'}
          ],
          threeLicenceCode: [
            { required: true,   validator: checkThreeLienceCode, trigger: 'change'},
            { validator: checkThreeLienceCodeFile, trigger: 'change' }
          ],
          licenceCode: [
            { required: true, message: '请输入营业执照代码', trigger: 'blur'},
            { validator: checkLicenceCodeFile, trigger: 'blur' }
          ],
          organizationCode: [
            { required: true, message: '请输入组织机构代码', trigger: 'blur'},
            { validator: checkOrganizationCodeFile, trigger: 'blur' }
          ],
          taxCode: [
            { required: true, message: '请输入税务登记证', trigger: 'blur'},
            { validator: checkTaxCodeFile, trigger: 'blur' }
          ],
          businessScope:[
            { required: true, message: '请输入主营业务', trigger: 'blur' },
            { min: 4, message: '您输入的内容过短', trigger: 'blur' }
          ],
          regFund: [
            { required: true, message: '请输入注册资金', trigger: 'blur'},
            { validator: checkNumber, trigger: 'blur' }
          ],
           businessBeginTime: [
            { required: true, message: '请输入营业开始时间', trigger: 'blur'},
            { validator: checkBussinessBeginime, trigger: 'blur' }
          ],
          industryShowContent:[
            { required: true, message: '请输入所属行业', trigger: 'change'}
          ],
          serviceShowContent:[
            { required: true, message: '请输入主要产品/服务', trigger: 'change'}
          ]
        }
      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-publicBanner': publicBanner,
      'v-footer': footer,
      'v-backToTop': backToTop
    },
    watch: {
      filterIndustryKey(val) {
        this.industryExpandedData = [];
        if(val == ''){
          this.filterIndustryFlag = false;
          // this.industryTree=this.industryTreeStorage;
          // this.$refs.tree2.filter();

          this.$axios.post('/onelink.mdata.main.api/uCenter/loadIndustries', {
          }).then((res) => {
            this.data = res.data;
            this.industryTree = this.data.rows;
            this.industryTreeStorage=JSON.parse(JSON.stringify(this.data.rows));
            this.industryTreeExt = this.data.rows;
          }).catch((err) => {
            console.log(err)
          })

          this.industryExpandedData = [];
        }else{
          this.filterIndustryNumber  = 0;
          this.filterIndustryFlag = true;
          this.$refs.tree2.filter(val);
        }
      },
      filterServiceKey(val){
         if(val == ''){
          this.filterServiceFlag = false;
          // this.serviceTree=this.serviceTreeStorage;
          // this.$refs.tree3.filter();
          this.$axios.post('/onelink.mdata.main.api/uCenter/loadServices', {
          }).then((res) => {
            this.data = res.data;
            this.serviceTree = this.data.rows;
            this.serviceTreeStorage = JSON.parse(JSON.stringify(this.data.rows));
          }).catch((err) => {
            console.log(err)
          })
        }else{
          this.filterServiceNumber = 0;
          this.filterServiceFlag = true;
          this.$refs.tree3.filter(val);
        }
      },
      newThreeLicenceCodeFileKey(val){
      }



    },
    computed:
    mapState([
      'KP'
    ]),
    newThreeLicenceCodeFileKey(){
      return this.baseInforRuleForm.threeLicenceCodeFileKey;
    }
    ,
    created () {
      if(this.getToken('isLogin') == 100){
        this.companyInfo = JSON.parse(this.getDAesString(this.getToken('companyInfo'),this.KP.key,this.KP.iv));
        this.orgId  = this.companyInfo.orgId;
      }
      let query = this.$route.query;
      this.groupDetailUrl = query.groupDetailUrl;
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCompleteInfo', {
        orgId:this.orgId
      }).then((res) => {
        this.data = res.data;
        this.webConfigInfo = this.data.webConfigInfoDto;
        this.footerColumnInfos = this.data.footerColumnInfos;
        this.navigationColumnInfos = this.data.navigationColumnInfos;
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
        this.countries = this.data.countries;
        this.provinces = this.data.provinces;
        this.cities = this.data.cities;
        this.ucenterInfo = this.data.uCenterOrgInformationDto;
        //初始化企业信息
        this.baseInforRuleForm.id = this.ucenterInfo.id ;
        this.baseInforRuleForm.orgIdentity = this.ucenterInfo.orgIdentity ;
        this.initOrgName = this.ucenterInfo.orgName ;
        this.baseInforRuleForm.orgName = this.ucenterInfo.orgName ;
        this.baseInforRuleForm.orgHead = this.ucenterInfo.orgHead ;
        this.baseInforRuleForm.regFund = this.ucenterInfo.regFund ;
        this.baseInforRuleForm.regFundCurrency = this.ucenterInfo.regFundCurrency ;
        this.baseInforRuleForm.foundDate = new Date(this.transferDate(this.ucenterInfo.foundDate)) ;
        this.baseInforRuleForm.businessBeginTime = new Date(this.transferDate(this.ucenterInfo.businessBeginTime)) ;

        if(Object.keys(this.ucenterInfo.businessEndTimeExt).length!=0){
          this.baseInforRuleForm.businessEndTime = new Date(this.transferDate(this.ucenterInfo.businessEndTime)) ;
          this.baseInforRuleForm.validTime = false;
        }else{
          this.baseInforRuleForm.validTime = true;
        }
        if(this.ucenterInfo.businessEndTime === ''){
          this.baseInforRuleForm.businessEndTime =new Date('2099-12-31');
          this.baseInforRuleForm.validTime = true;
          this.businessEndTimeShowFlag = false;
        }else{
          this.baseInforRuleForm.businessEndTime = new Date(this.transferDate(this.ucenterInfo.businessEndTime)) ;
          this.baseInforRuleForm.validTime = false;
          if (this.ucenterInfo.businessEndTime == '4102329600000') {
            this.baseInforRuleForm.validTime = true;
            this.businessEndTimeShowFlag = false;
          }
        }
        this.baseInforRuleForm.regAddrCountry = this.ucenterInfo.regAddrCountry ;
        if(this.baseInforRuleForm.regAddrCountry !='86'){
          this.addressFlag = false;
        }else{
          this.addressFlag = true;
        }
        this.baseInforRuleForm.regAddrProvince = this.ucenterInfo.regAddrProvince ;
        this.baseInforRuleForm.regAddrCity = this.ucenterInfo.regAddrCity ;
        this.baseInforRuleForm.regAddrDetail = this.ucenterInfo.regAddrDetail ;
        this.baseInforRuleForm.regAddrType = this.ucenterInfo.regAddrType ;
        if(this.baseInforRuleForm.regAddrType == '0'){
          this.threeShowflag = true;
          this.regeistFileName = '统一社会信用代码';
          this.regeistFileDisableFlag = true;
          this.companyDiabledFlag = true;
          this.showFlag = true;
          this.showButtonFlag = true;
      }
      if(this.baseInforRuleForm.regAddrType == '1'){
        this.threeShowflag = false;
        this.regeistFileName = '商业登记注册号';
        this.regeistFileDisableFlag = false;
        this.baseInforRuleForm.threeLicenceCode = this.ucenterInfo.licenceCode;
        this.companyDiabledFlag = false;
        this.showFlag = false;
        this.showButtonFlag = null;
      }
        this.baseInforRuleForm.isThreeToOne = this.ucenterInfo.isThreeToOne ;
        //如果是三证合一
        if(this.ucenterInfo.isThreeToOne == '1' || this.ucenterInfo.isThreeToOne == ''){
          this.threeFlag = true;
          this.baseInforRuleForm.threeLicenceCode = this.ucenterInfo.licenceCode ;
          if(Object.keys(this.ucenterInfo.licenceDocFile).length >0){
            this.baseInforRuleForm.threeLicenceCodeFileUrl = this.ucenterInfo.licenceDocFile.fileUrl ;
            this.baseInforRuleForm.threeLicenceCodeFileKey = this.ucenterInfo.licenceDocFile.fileUrl ;
            if(this.baseInforRuleForm.threeLicenceCodeFileUrl !=''){
              this.showThreeLienceFlag = true;
            }
            this.baseInforRuleForm.threeLicenceCodeFileName = this.ucenterInfo.licenceDocFile.fileName ;
            if(this.baseInforRuleForm.threeLicenceCodeFileName){
              this.showThreeLienceFlag=true;
            }else{
              this.showThreeLienceFlag=false;
            }
          }

        }
        //如果不是三证合一
        if(this.ucenterInfo.isThreeToOne == '0'){
          this.threeFlag = false;
          this.baseInforRuleForm.licenceCode = this.ucenterInfo.licenceCode ;
          if(Object.keys(this.ucenterInfo.licenceDocFile).length >0){
            this.baseInforRuleForm.licenceCodeFileUrl = this.ucenterInfo.licenceDocFile.fileUrl ;
            this.baseInforRuleForm.licenceCodeFileName = this.ucenterInfo.licenceDocFile.fileName ;
            if(this.baseInforRuleForm.licenceCodeFileName){
              this.deleteLicTxt="删除"
            }else{
              this.deleteLicTxt=""
            }
            this.baseInforRuleForm.licenceCodeFileKey = this.ucenterInfo.licenceDocFile.fileUrl ;
            if(this.baseInforRuleForm.licenceCodeFileUrl !=''){
              this.showLienceFlag = true;
            }
          }

          this.baseInforRuleForm.organizationCode = this.ucenterInfo.organizationCode ;
          if(Object.keys(this.ucenterInfo.organizationCodeFile).length >0){
            this.baseInforRuleForm.organizationCodeFileUrl = this.ucenterInfo.organizationCodeFile.fileUrl ;
            this.baseInforRuleForm.organizationCodeFileName = this.ucenterInfo.organizationCodeFile.fileName ;
            if(this.baseInforRuleForm.organizationCodeFileName){
              this.deleteOrgTxt='删除'
            }else{
              this.deleteOrgTxt=''
            }

            this.baseInforRuleForm.organizationCodeFileKey = this.ucenterInfo.organizationCodeFile.fileUrl ;
            if(this.baseInforRuleForm.organizationCodeFileUrl !=''){
              this.showOrganizationFlag = true;
            }
          }
          this.baseInforRuleForm.taxCode = this.ucenterInfo.taxCode ;
          if(Object.keys(this.ucenterInfo.organizationCodeFile).length >0){
            this.baseInforRuleForm.taxCodeFileUrl = this.ucenterInfo.taxCodeFile.fileUrl ;
            this.baseInforRuleForm.taxCodeFileName = this.ucenterInfo.taxCodeFile.fileName ;
            if(this.baseInforRuleForm.taxCodeFileName){
              this.deleteTaxTxt="删除"
            }else{
              this.deleteTaxTxt=""
            }
            this.baseInforRuleForm.taxCodeFileKey = this.ucenterInfo.taxCodeFile.fileUrl ;
            if(this.baseInforRuleForm.taxCodeFileUrl !=''){
              this.showTaxFlag = true;
            }
          }
        }

        if(Object.keys(this.ucenterInfo.serviceDtos).length>0){
          this.baseInforRuleForm.serviceDtos = this.ucenterInfo.serviceDtos;
          // this.baseInforRuleForm.serviceShowContent = "";
          let serviceNumber = 0;
          this.baseInforRuleForm.serviceDtos.forEach(element =>{
            if(element.children == ""){
              element.children = [];
            }
            let selectServiceame = element.serviceName;
            this.serviceData = {serviceName:"",id:0};
            this.serviceData.id = serviceNumber;
            let filterIndexStart=selectServiceame.indexOf('<span')
            let filterIndexEnd=selectServiceame.indexOf('</span>')
            if(filterIndexStart !=-1 && filterIndexEnd!=-1){
              selectServiceame=selectServiceame.slice(0,filterIndexStart)+selectServiceame.slice(filterIndexStart+24,filterIndexEnd)+selectServiceame.slice(filterIndexEnd+7)
            }
            this.serviceData.serviceName = selectServiceame;
            this.serviceDatas.push(this.serviceData);
            serviceNumber++;
            this.baseInforRuleForm.serviceShowContent=this.baseInforRuleForm.serviceShowContent + '[' + selectServiceame + ']';
          })
        }

        this.baseInforRuleForm.serviceDatas = this.serviceDatas;

        // this.baseInforRuleForm.bussinessChangeFileUrl = this.ucenterInfo.authFileUrl;
        // this.baseInforRuleForm.bussinessChangeFileName = this.ucenterInfo.authFileName;
        if(Object.keys(this.ucenterInfo.industriesDtos).length>0){
          this.baseInforRuleForm.industriesDtos = this.ucenterInfo.industriesDtos;
          this.baseInforRuleForm.industryShowContent = "";
          let industryNumber = 0;
          this.baseInforRuleForm.industriesDtos.forEach(element =>{
            if(element.children == ""){
              element.children = [];
            }
            let selectIndustryName = element.industryName;
            this.industryData = {industryName:"",id:0};
            this.industryData.id = industryNumber;
            let filterIndexStart=selectIndustryName.indexOf('<span')
            let filterIndexEnd=selectIndustryName.indexOf('</span>')
            if(filterIndexStart !=-1 && filterIndexEnd!=-1){
              selectIndustryName=selectIndustryName.slice(0,filterIndexStart)+selectIndustryName.slice(filterIndexStart+24,filterIndexEnd)+selectIndustryName.slice(filterIndexEnd+7)
            }
            this.industryData.industryName = selectIndustryName;
            this.industryDatas.push(this.industryData);
            industryNumber++;
            this.baseInforRuleForm.industryShowContent=this.baseInforRuleForm.industryShowContent + '[' + selectIndustryName + ']';
          })
          this.baseInforRuleForm.industryDatas = this.industryDatas;
        }





        this.baseInforRuleForm.businessScope = this.ucenterInfo.businessScope ;

        //监控数据变化
        this.$watch('baseInforRuleForm.orgName', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.orgHead', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.regFund', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.regFundCurrency', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.foundDate', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.businessBeginTime', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.businessEndTime', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.validTime', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.regAddrCountry', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.regAddrProvince', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.regAddrCity', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.regAddrDetail', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.serviceShowContent', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.industryShowContent', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.businessScope', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.regAddrType', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.isThreeToOne', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.threeLicenceCode', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.licenceCode', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.organizationCode', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.taxCode', function(){
           this.editFlag = true;
          }, {deep: true}
        )

        //监控数据变化
        this.$watch('baseInforRuleForm.threeLicenceCodeFileName', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.licenceCodeFileName', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.organizationCodeFileName', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.taxCodeFileName', function(){
           this.editFlag = true;
          }, {deep: true}
        )
        //监控数据变化
        this.$watch('baseInforRuleForm.bussinessChangeFileName', function(){
           this.editFlag = true;
          }, {deep: true}
        )
      }).catch((err) => {
        console.log(err)
      })

    },
    mounted () {
      this.hideLise();

    },
    methods: {
      redirectGroup(){
        window.location.href=this.groupDetailUrl;
      },
      hideLise(){
        $('body').click(()=>{
          this.companyListShow=false
        })
      },
      updateButton(val){
        if(this.initOrgName !=val){
          this.showButtonFlag = false;
        }else{
          this.showButtonFlag = true;
        }
      },
      loadCompanys(){
        this.selectCompanyName='';
        this.searchVagueCompany = this.baseInforRuleForm.orgName;
        this.$axios.post('/onelink.mdata.main.api/credit/creditFuzzyQuery', {
          companyName: this.baseInforRuleForm.orgName,
          pageNo:1,
          pageSize:10
        }).then((res) => {
          if(res.data.length>0){
            this.companyListShow=true;
          }else{
            this.$alert('<i class="el-icon-error" style="font-size: 32px;color: #F56C6C;position: absolute"></i><p style="padding-left: 48px">抱歉，没有找到相关结果！您可以:</p><p style="padding-left: 48px">1.输入准确的关键词，重新搜索</p><p style="padding-left: 48px">2.点击屏幕右侧"咨询客服"与我们在线沟通。</p>', '', {
              dangerouslyUseHTMLString: true
            });
          }
          this.data = res.data;
          this.companyData = [];
          this.companyData = this.data;
          // this.baseInforRuleForm.orgName = this.searchVagueCompany;
        }).catch((err) => {
          console.log(err)
        })

      },
      selectCompany(companyId){
        this.baseInforRuleForm.orgName = companyId;
        this.companySearch = this.selectCompanyName;
        // this.baseInforRuleForm.orgName =companyId.split(",")[1];
        this.$axios.post('/onelink.mdata.main.api/mainInfo/findCreditcompanyInfo', {
          companyName: this.baseInforRuleForm.orgName,
          pageNo:1,
          pageSize:10
        }).then((res) => {
          this.data = res.data;
          if(this.data.length == 0){
            this.$message({
              dangerouslyUseHTMLString: true,
              message: '<strong style="color:gray;font-size:8px">抱歉没有收到相关结果！你可以：<br/>1.输入准确的关键字，重新搜索<br/>2.点击屏幕右侧"咨询客服"与我们在线沟通。</strong>',
              type: 'error'
            });
            this.companyListShow=false;
            return false;
          }else{
            this.creditCompanyInfo =  this.data.companyInfo;
            this.cities = this.data.cities;
            this.baseInforRuleForm.orgName = this.creditCompanyInfo.companyName;
            this.baseInforRuleForm.regAddrCountry = '86';
            this.baseInforRuleForm.regAddrProvince = this.creditCompanyInfo.province;
            this.baseInforRuleForm.regAddrCity = this.creditCompanyInfo.city;
            this.baseInforRuleForm.regAddrDetail = this.creditCompanyInfo.address;
            if(this.creditCompanyInfo.registCapi == '-'){
              this.baseInforRuleForm.regFund = '';
            }else{
              this.baseInforRuleForm.regFund = this.creditCompanyInfo.registCapi;
            }
            this.baseInforRuleForm.businessScope = this.creditCompanyInfo.scope;
            this.baseInforRuleForm.businessBeginTime = new Date(this.creditCompanyInfo.termStart);
            this.baseInforRuleForm.businessEndTime = new Date(this.creditCompanyInfo.termEnd);
            if(this.creditCompanyInfo.termEnd === ''){
              this.baseInforRuleForm.businessEndTime =new Date('2099-12-31');
              this.baseInforRuleForm.validTime = true;
              this.businessEndTimeShowFlag = false;
            }else{
              this.baseInforRuleForm.businessEndTime = new Date(this.creditCompanyInfo.termEnd);
              this.baseInforRuleForm.validTime = false;
              if (this.creditCompanyInfo.termEnd == '4102329600000') {
                this.baseInforRuleForm.validTime = true;
                this.businessEndTimeShowFlag = false;
              }
            }
            this.baseInforRuleForm.orgHead = this.creditCompanyInfo.operName;
            this.baseInforRuleForm.foundDate =  new Date(this.creditCompanyInfo.startDate);
            this.baseInforRuleForm.orgCode = this.creditCompanyInfo.orgNo;
            if(this.creditCompanyInfo.creditNo =='' || this.creditCompanyInfo.creditNo =='-'){
              this.baseInforRuleForm.licenceCode = this.creditCompanyInfo.regNo;
              this.threeFlag = false;
              this.baseInforRuleForm.isThreeToOne = '0';
            }else{
              this.baseInforRuleForm.threeLicenceCode = this.creditCompanyInfo.creditNo;
              this.threeFlag = true;
              this.baseInforRuleForm.isThreeToOne = '1';
            }
          }
          this.companyListShow=false;
        }).catch((err) => {
          console.log(err)
        })


      },
      selectCompanyExt(){
        this.companySearch = this.selectCompanyName;
        // this.baseInforRuleForm.orgName =companyId.split(",")[1];
        this.$axios.post('/onelink.mdata.main.api/mainInfo/findCreditcompanyInfo', {
          companyName: this.baseInforRuleForm.orgName,
          pageNo:1,
          pageSize:10
        }).then((res) => {
          this.data = res.data;
          if(Object.keys(this.data.companyInfo).length == 0){
            this.$message({
              dangerouslyUseHTMLString: true,
              message: '<strong style="color:gray;font-size:8px">抱歉没有收到相关结果！你可以：<br/>1.输入准确的关键字，重新搜索<br/>2.点击屏幕右侧"咨询客服"与我们在线沟通。</strong>',
              type: 'error'
            });
            this.companyListShow=false;
            return false;
          }else{
            this.creditCompanyInfo =  this.data.companyInfo;
            this.cities = this.data.cities;
            this.baseInforRuleForm.orgName = this.creditCompanyInfo.companyName;
            this.baseInforRuleForm.regAddrCountry = '86';
            this.baseInforRuleForm.regAddrProvince = this.creditCompanyInfo.province;
            this.baseInforRuleForm.regAddrCity = this.creditCompanyInfo.city;
            this.baseInforRuleForm.regAddrDetail = this.creditCompanyInfo.address;
            if(this.creditCompanyInfo.registCapi == '-'){
              this.baseInforRuleForm.regFund = '';
            }else{
              this.baseInforRuleForm.regFund = this.creditCompanyInfo.registCapi;
            }
            this.baseInforRuleForm.businessScope = this.creditCompanyInfo.scope;
            this.baseInforRuleForm.businessBeginTime = new Date(this.creditCompanyInfo.termStart);
            this.baseInforRuleForm.businessEndTime = new Date(this.creditCompanyInfo.termEnd);
            if(this.creditCompanyInfo.termEnd === ''){
              this.baseInforRuleForm.businessEndTime =new Date('2099-12-31');
              this.baseInforRuleForm.validTime = true;
              this.businessEndTimeShowFlag = false;
            }else{
              this.baseInforRuleForm.businessEndTime = new Date(this.creditCompanyInfo.termEnd);
              this.baseInforRuleForm.validTime = false;
              if (this.creditCompanyInfo.termEnd == '4102329600000') {
                this.baseInforRuleForm.validTime = true;
                this.businessEndTimeShowFlag = false;
              }
            }
            this.baseInforRuleForm.orgHead = this.creditCompanyInfo.operName;
            this.baseInforRuleForm.foundDate =  new Date(this.creditCompanyInfo.startDate);
            this.baseInforRuleForm.orgCode = this.creditCompanyInfo.orgNo;
            if(this.creditCompanyInfo.creditNo =='' || this.creditCompanyInfo.creditNo =='-'){
              this.baseInforRuleForm.licenceCode = this.creditCompanyInfo.regNo;
              this.threeFlag = false;
              this.baseInforRuleForm.isThreeToOne = '0';
            }else{
              this.baseInforRuleForm.threeLicenceCode = this.creditCompanyInfo.creditNo;
              this.threeFlag = true;
              this.baseInforRuleForm.isThreeToOne = '1';
            }
          }
          this.companyListShow=false;
        }).catch((err) => {
          console.log(err)
        })


      },
      findCompanyInfo(){
        this.$axios.post('/onelink.mdata.main.api/credit/creditFuzzyQuery', {
          companyName: this.baseInforRuleForm.orgName,
          pageNo:1,
          pageSize:10
        }).then((res) => {
          if(res.data.length>0){
            this.companyListShow=true;
          }else{
            this.$alert('<i class="el-icon-error" style="font-size: 32px;color: #F56C6C;position: absolute"></i><p style="padding-left: 48px">抱歉，没有找到相关结果！您可以:</p><p style="padding-left: 48px">1.输入准确的关键词，重新搜索</p><p style="padding-left: 48px">2.点击屏幕右侧"咨询客服"与我们在线沟通。</p>', '', {
              dangerouslyUseHTMLString: true
            });
          }
          this.data = res.data;
          this.companyData = [];
//          if(this.data.length == 0){
//            this.$message({
//              dangerouslyUseHTMLString: true,
//              message: '<strong style="color:gray;font-size:8px">征信系统无法查询到您输入的企业信息<br/>请检查企业名称是否输入有误。<br/><p></p><br/>如有疑问请联系客服400-108-6116</strong>',
//              type: 'success'
//            });
//            return false;
//          }
          this.companyData = this.data;
          this.ruleForm.companyName = this.searchVagueCompany;
          this.findCreditFlag = true;
        }).catch((err) => {
          console.log(err)
        })
      },
      changeValidTime(val){
        this.baseInforRuleForm.validTime = val;
        if(val){
          this.businessEndTimeShowFlag = false;
          this.baseInforRuleForm.businessEndTime =new Date('2099-12-31');
        }else{
          this.baseInforRuleForm.businessEndTime =null;
          this.businessEndTimeShowFlag = true;
        }
        this.$refs['perfectionForm'].validate((valid) => {});
      },
      submitForm(formName) {
      let isEnableDeleteContent = "您的企业信息已更新，请确认是否已重新上传营业执照及相关附件";
      this.$confirm(isEnableDeleteContent, '', {
          confirmButtonText: '是，确认提交变更信息',
          cancelButtonText: '否，现在立即上传',
        }).then(res => {
          this.$refs[formName].validate((valid) => {
            if (valid) {

            this.$axios.post('/onelink.mdata.main.api/company/updateCompanyInfo', {
                id:this.baseInforRuleForm.id,
                orgIdentity: this.baseInforRuleForm.orgIdentity,
                orgName: this.baseInforRuleForm.orgName,
                orgHead: this.baseInforRuleForm.orgHead,
                regFund: this.baseInforRuleForm.regFund,
                regFundCurrency:this.baseInforRuleForm.regFundCurrency,
                foundDate:this.baseInforRuleForm.foundDate,
                businessBeginTime: this.baseInforRuleForm.businessBeginTime,
                businessEndTime: this.baseInforRuleForm.businessEndTime,
                regAddrCountry: this.baseInforRuleForm.regAddrCountry,
                regAddrProvince:this.baseInforRuleForm.regAddrProvince,
                regAddrCity:this.baseInforRuleForm.regAddrCity,
                regAddrDetail:this.baseInforRuleForm.regAddrDetail,
                regAddrType:this.baseInforRuleForm.regAddrType,
                isThreeToOne:this.baseInforRuleForm.isThreeToOne,
                threeLicenceCode:this.baseInforRuleForm.threeLicenceCode,
                threeLicenceCodeFileUrl:this.baseInforRuleForm.threeLicenceCodeFileKey,
                threeLicenceCodeFileName:this.baseInforRuleForm.threeLicenceCodeFileName,
                licenceCode:this.baseInforRuleForm.licenceCode,
                licenceCodeFileUrl:this.baseInforRuleForm.licenceCodeFileKey,
                licenceCodeFileName:this.baseInforRuleForm.licenceCodeFileName,
                organizationCode:this.baseInforRuleForm.organizationCode,
                organizationCodeFileUrl:this.baseInforRuleForm.organizationCodeFileKey,
                organizationCodeFileName:this.baseInforRuleForm.organizationCodeFileName,
                taxCode:this.baseInforRuleForm.taxCode,
                taxCodeFileUrl:this.baseInforRuleForm.taxCodeFileKey,
                taxCodeFileName:this.baseInforRuleForm.taxCodeFileName,
                industriesDtos:this.baseInforRuleForm.industriesDtos,
                serviceDtos:this.baseInforRuleForm.serviceDtos,
                businessScope:this.baseInforRuleForm.businessScope,
                majorBussiness:this.baseInforRuleForm.businessScope,
                bussinessChangeFileUrl:this.baseInforRuleForm.bussinessChangeFileKey,
                bussinessChangeFileName:this.baseInforRuleForm.bussinessChangeFileName
            }).then((res) => {
                this.data = res.data;
                let operateFlag = this.data.data.completeFlag;
                if(operateFlag){
                  // this.setToken('checkFlag',100);
                  this.$message({
                      message: "企业变更信息已提交，请耐心等待审核结果！",
                      type: 'success'
                  });
                  this.removeCookie("COMPANY_COMPLETE_STATUS_"+this.baseInforRuleForm.id);
                  this.setCookie("COMPANY_COMPLETE_STATUS_"+this.baseInforRuleForm.id,1)
                  this.centerDialogVisible = false;
                  this.$router.push({path:'/'})
                }else{
                  this.$message({
                      message: this.data.data.errorInfo,
                      type: 'error'
                  });
                }
              }).catch((err) => {
                console.log(err)
              })
            } else {
              this.$message({
                    message: "有未输入的必填项,请仔细检查后重新输入",
                    type: 'error'
              });
              console.log('error submit!!');
              return false;
            }
          });
        }).catch((err) => {
            console.log(err)
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      selectCountry(countryCode){
        if(countryCode !='86'){
          this.addressFlag = false;
        }else{
          this.addressFlag = true;
        }
        this.baseInforRuleForm.regAddrCountry = countryCode;
        this.baseInforRuleForm.regAddrProvince = '';
        this.baseInforRuleForm.regAddrCity = '';
        this.$axios.post('/onelink.mdata.main.api/region/getProvinces', {
          countryCode:countryCode
        }).then((res) => {
          this.data = res.data;
          this.provinces = this.data;
        }).catch((err) => {
          console.log(err)
        })
      },
      selectProvince(proviceCode){
        this.baseInforRuleForm.regAddrProvince = proviceCode;
        this.baseInforRuleForm.regAddrCity = '';
        this.$axios.post('/onelink.mdata.main.api/region/getCities', {
          provinceCode:proviceCode
        }).then((res) => {
          this.data = res.data;
          this.cities = this.data;
        }).catch((err) => {
          console.log(err)
        })
      },
      selectCity(cityCode){
        this.baseInforRuleForm.regAddrCity = cityCode;
      },
      selectThreeToOne(three){
        if(three == '0'){
          this.threeFlag = false;
          // this.baseInforRuleForm.licenceCodeFileUrl = '';
          // this.baseInforRuleForm.licenceCodeFileName = '';
          // this.baseInforRuleForm.organizationCodeFileUrl = '';
          // this.baseInforRuleForm.organizationCodeFileName = '';
          // this.baseInforRuleForm.taxCodeFileUrl = '';
          // this.baseInforRuleForm.taxCodeFileName = '';
        }
        if(three == '1'){
          this.threeFlag = true;
          // this.baseInforRuleForm.threeLicenceCodeFileName = '';
          // this.baseInforRuleForm.threeLicenceCodeFileUrl = '';
        }
        this.regeistFileDisableFlag = false;
      },
      checkSupplier(check){
        if(!check){
          this.baseInforRuleForm.orgIdentityCheckP = true;
          this.baseInforRuleForm.orgIdentity = '20';
        }else{
          this.baseInforRuleForm.orgIdentityCheckP = false;
          this.baseInforRuleForm.orgIdentity = '10';
        }
      },
      checkPurchaser(check){
        if(!check){
          this.baseInforRuleForm.orgIdentityCheckS = true;
          this.baseInforRuleForm.orgIdentity = '10';
        }else{
          this.baseInforRuleForm.orgIdentityCheckS = false;
          this.baseInforRuleForm.orgIdentity = '20';
        }
      },
     openIndutry(){
        this.filterIndustryKey = '';
        this.openFullScreen(2000);
        this.loading = true;
        this.industryShowFlag = true;
        this.$axios.post('/onelink.mdata.main.api/uCenter/loadIndustries', {
        }).then((res) => {
          this.data = res.data;
          this.industryTree = this.data.rows;
       this.industryTreeStorage=JSON.parse(JSON.stringify(this.data.rows));
          this.industryTreeExt = this.data.rows;
          this.loading = false;
        }).catch((err) => {
          console.log(err)
        })
      },
      filterIndustry(value, data) {
        if (!value) return true;
        if(typeof(data.parent) == "undefined" && data.children !=""){
          data.children.forEach(element =>{
            element.parent = data;
          })
        }
//        去掉html
        let textStr = data.industryName.split('<span style="color:red">').join("");
        data.industryName=textStr.split("</span>").join("")
        if(data.industryName.indexOf(value) == -1){
          let industryCheckFlag = false;
          if(typeof(data.parent) != "undefined" ){
            let childrenIndustryNames = '';
            for (let i = 0; i < data.parent.children.length; i++) {
              const element = data.parent.children[i];
              childrenIndustryNames = childrenIndustryNames +element.industryName;
            }
            if(childrenIndustryNames.indexOf(value) == -1 && data.parent.industryName.indexOf(value) != -1){
              industryCheckFlag = true;
            }else{
              industryCheckFlag = false;
            }
          }
          return industryCheckFlag;
        }else{
          let num = data.industryName.indexOf(value);
          data.industryName=data.industryName.slice(0,num)+'<span style="color:red">'+value+'</span>'+data.industryName.slice(num+value.length)
          this.filterIndustryNumber++;
          return true;
        }
      },
      filterSerivce(value, data) {
        if (!value) return true;
        if(typeof(data.parent) == "undefined" && data.children !=""){
          data.children.forEach(element =>{
            element.parent = data;
          })
        }
//        去掉html
        let textStr = data.serviceName.split('<span style="color:red">').join("");
        data.serviceName=textStr.split("</span>").join("")
        // this.serviceTree.push(data);
        if(data.serviceName.indexOf(value) == -1){
          let serviceCheckFlag = false;
          if(typeof(data.parent) != "undefined" && data.children!=""){
            let childrenServiceNames = '';
            for (let i = 0; i < data.parent.children.length; i++) {
              const element = data.parent.children[i];
              childrenServiceNames = childrenServiceNames +element.serviceName;
            }
            if(childrenServiceNames.indexOf(value) == -1 && data.parent.serviceName.indexOf(value) != -1){
              serviceCheckFlag = true;
            }else{
              serviceCheckFlag = false;
            }
          }
          return serviceCheckFlag;
        }else{
          let num = data.serviceName.indexOf(value);
          data.serviceName=data.serviceName.slice(0,num)+'<span style="color:red">'+value+'</span>'+data.serviceName.slice(num+value.length)
          this.filterServiceNumber++;
          return true;
        }
      },
      openService(){
        this.filterServiceKey = '';
        this.openFullScreen(2000);
        this.loading = true;
        this.serviceShowFlag = true;
        this.$axios.post('/onelink.mdata.main.api/uCenter/loadServices', {
        }).then((res) => {
          this.data = res.data;
          this.serviceTree = this.data.rows;
          this.serviceTreeStorage = JSON.parse(JSON.stringify(this.data.rows));
          this.loading = false;
        }).catch((err) => {
          console.log(err)
        })
      },
      changeIndustry(val){
        this.multipleIndustrySelection = val;
      },
      changeService(val){
        this.multipleServiceSelection = val;
      },
      handleCheckIndustryChange(data, checked, indeterminate) {
        let selectIndustry = {};
        selectIndustry.id = data.id;
        selectIndustry.industryName = data.industryName;
        // this.baseInforRuleForm.industriesDtos.push(selectIndustry);
        this.baseInforRuleForm.industriesExtDtos.push(selectIndustry);
      },
      handleCheckServiceChange(data, checked, indeterminate) {
        let selectService = {};
        selectService.id = data.id;
        selectService.serviceName = data.serviceName;
        this.baseInforRuleForm.serviceExtDtos.push(selectService);
        // this.baseInforRuleForm.serviceDtos.push(selectService);
        // 自动展开下级
        this.$refs.tree3.store.nodesMap[data.id].expanded = true;
        this.expandedTreeItemHandler(data.children);
      },
      expandedTreeItemHandler (list) {
        if (list && list.length) {
          list.forEach((childrenItem) => {
            this.$refs.tree3.store.nodesMap[childrenItem.id].expanded = true;
            if (childrenItem.children) {
              this.expandedTreeItemHandler(childrenItem.children);
            }
          })
        }
      },
      prewIndustry(){
        this.industryDatas = [];
        this.industryShowFlag = false;
        this.baseInforRuleForm.industriesDtos = this.$refs.tree2.getCheckedNodes();
        this.baseInforRuleForm.industryShowContent = "";
        let industryNumber = 0;
        this.baseInforRuleForm.industriesDtos.forEach(element =>{
          element.children = [];
//          let filterIndexStart=element.industryName.indexOf('<span')
//          let filterIndexEnd=element.industryName.indexOf('</span>')
          let selectIndustryName = '';
//          if(filterIndexStart !=-1 && filterIndexEnd!=-1){
//            selectIndustryName=element.industryName.slice(0,filterIndexStart)+element.industryName.slice(filterIndexStart+24,filterIndexEnd)+element.industryName.slice(filterIndexEnd+7)
//          }else{
//            selectIndustryName=element.industryName;
//          }
          let textStr = element.industryName.split('<span style="color:red">').join("");

          selectIndustryName=textStr.split("</span>").join("")
//        提交数据处理
        delete element.parent;
        this.industryData = element
//          this.industryData = {industryName:"",id:0};
//          this.industryData.id = industryNumber;
          this.industryData.industryName = selectIndustryName;
          this.industryDatas.push(this.industryData);
          industryNumber++;
          this.baseInforRuleForm.industryShowContent=this.baseInforRuleForm.industryShowContent + '[' + selectIndustryName + ']';
        })
        this.baseInforRuleForm.industryDatas = this.industryDatas;
//        提交数据处理
        this.baseInforRuleForm.industriesDtos = this.industryDatas;
        this.$refs['perfectionForm'].validate((valid) => {});
      },
      removeIndustry(industryName,id){
        this.industryDatas.forEach((element,index) =>{
          if(element.id == id){
            this.industryDatas.splice(index,1);
          }
        });
//        let industryNumber = 0;
        this.baseInforRuleForm.industryShowContent = "";
        let industryExtDatas = this.industryDatas;
//        this.industryDatas = [];
        industryExtDatas.forEach(element =>{
          let selectIndustryName = element.industryName;
//          this.industryData = {industryName:"",id:0};
//          this.industryData.id = industryNumber;
//          this.industryData.industryName = selectIndustryName;
//          this.industryDatas.push(this.industryData);
//          industryNumber++;
          this.baseInforRuleForm.industryShowContent=this.baseInforRuleForm.industryShowContent + '[' + selectIndustryName + ']';
        });
        this.baseInforRuleForm.industryDatas = this.industryDatas;
        this.$refs['perfectionForm'].validate((valid) => {});
      },
      prewService(){
        let checkedNodes = this.$refs.tree3.getCheckedNodes();
        if (checkedNodes && checkedNodes.length && checkedNodes.length > 20) {
          this.$message.error("您最多可选择20个分类，准确的选择您企业提供的产品与服务分类，更有利于您企业获取精准商机")
          return false
        }
        this.serviceDatas = [];
        this.serviceShowFlag = false;
        this.baseInforRuleForm.serviceDtos = checkedNodes
        this.baseInforRuleForm.serviceShowContent = "";
        let serviceNumber = 0;
        this.baseInforRuleForm.serviceDtos.forEach(element =>{
          element.children = [];
//          let filterIndexStart=element.serviceName.indexOf('<span')
//          let filterIndexEnd=element.serviceName.indexOf('</span>')
          let selectServiceame = '';
//          if(filterIndexStart != -1 && filterIndexEnd != -1){
//            selectServiceame=element.serviceName.slice(0,filterIndexStart)+element.serviceName.slice(filterIndexStart+24,filterIndexEnd)+element.serviceName.slice(filterIndexEnd+7)
//          }else{
//            selectServiceame=element.serviceName;
//          }
          let textStr = element.serviceName.split('<span style="color:red">').join("");

          selectServiceame=textStr.split("</span>").join("")
//        提交数据处理
        delete element.parent;
        this.serviceData = element;
//          this.serviceData = {serviceName:"",serviceIndex:0};
//          this.serviceData.serviceIndex = serviceNumber;
          this.serviceData.serviceName = selectServiceame;
          this.serviceDatas.push(this.serviceData);
          serviceNumber++;
          this.baseInforRuleForm.serviceShowContent=this.baseInforRuleForm.serviceShowContent + '[' + selectServiceame + ']';
        })
        this.baseInforRuleForm.serviceDatas = this.serviceDatas;
//        提交数据处理
        this.baseInforRuleForm.serviceDtos = this.serviceDatas;
        this.$refs['perfectionForm'].validate((valid) => {});
      },

      removeService(serviceName,id){
        this.serviceDatas.forEach((element,index) =>{
          if(element.id == id){
            this.serviceDatas.splice(index,1);
          }
        });
        this.baseInforRuleForm.serviceShowContent = "";
//        let serviceNumber = 0;
        let serviceExtDatas = this.serviceDatas;
//        this.serviceDatas = [];
        serviceExtDatas.forEach(element =>{
          let selectServiceame = element.serviceName;
//          this.serviceData = {serviceName:"",id:0};
//          this.serviceData.id = serviceNumber;
//          this.serviceData.serviceName = selectServiceame;
//          this.serviceDatas.push(this.serviceData);
//          serviceNumber++;
          this.baseInforRuleForm.serviceShowContent=this.baseInforRuleForm.serviceShowContent + '[' + selectServiceame + ']';
        });
        this.baseInforRuleForm.serviceDatas = this.serviceDatas;
        this.$refs['perfectionForm'].validate((valid) => {});
      },
      closeIndustry(){
        this.industryShowFlag = false;
      },
      closeService(){
        this.serviceShowFlag = false;
      },
      tirggerThreeLienceCodeFile(event){
        if(this.baseInforRuleForm.threeLicenceCodeFileUrl!=''){
          this.$message({
                message: "您已上传附件，若您需要更新附件，请先删除原附件",
                type: 'error'
          });
          return false;
        }
        let file = event.target.files[0];
        let fileName = String(file.name);
        let fileSize = file.size;
        var AllImgExt=".jpg|.jpeg|.png|.pdf|";
        var extName = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
        if(AllImgExt.indexOf(extName+"|")==-1){
          this.$message({
                message: "仅支持JPG、JPEG、PNG、PDF格式",
                type: 'error'
          });
          return false;
        }
        if(fileSize/1024/1024 >10){
          this.$message({
                message: "上传文件不得超过10M",
                type: 'error'
          });
          return false;
        }
        this.baseInforRuleForm.upfile = event.target.files; // (利用console.log输出看结构就知道如何处理档案资料)
        let formData = new FormData();
        formData.append('upfile', file);
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        this.$axios.post('/onelink.mdata.main.api/upload/uploadSync', formData,config).then((res) => {
          this.data = res.data;
          this.baseInforRuleForm.threeLicenceCodeFileName = this.data.fileName;
          if(this.baseInforRuleForm.threeLicenceCodeFileName){
            this.deleteThreeLicTxt="删除";
          }else{
            this.deleteThreeLicTxt="";
          }
          this.baseInforRuleForm.threeLicenceCodeFileUrl = this.data.fileUrl;
          this.baseInforRuleForm.threeLicenceCodeFileKey = this.data.fileKey;
          this.baseInforRuleForm.threeLicenceCode = this.baseInforRuleForm.threeLicenceCode + " ";
          this.showThreeLienceFlag = true;
          this.$refs['perfectionForm'].validate((valid) => {});

          // this.baseInforRuleForm.threeLicenceCode = currentThreeLicenceCode;
        }).catch((err) => {
          console.log(err)
        })
      },
      viewAttachment(url){
        window.location.href=url;
      },
      tirggerLienceCodeFile(event){
        if(this.baseInforRuleForm.licenceCodeFileUrl!=''){
          this.$message({
                message: "您已上传附件，若您需要更新附件，请先删除原附件",
                type: 'error'
          });
          return false;
        }
        let file = event.target.files[0];
        let fileName = String(file.name);
        let fileSize = file.size;
        var AllImgExt=".jpg|.jpeg|.png|.pdf|";
        var extName = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
        if(AllImgExt.indexOf(extName+"|")==-1){
          this.$message({
                message: "仅支持JPG、JPEG、PNG、PDF格式",
                type: 'error'
          });
          return false;
        }
        if(fileSize/1024/1024 >10){
          this.$message({
                message: "上传文件不得超过10M",
                type: 'error'
          });
          return false;
        }
        this.baseInforRuleForm.upfile = event.target.files; // (利用console.log输出看结构就知道如何处理档案资料)
        let formData = new FormData();
        formData.append('upfile', file);
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        this.$axios.post('/onelink.mdata.main.api/upload/uploadSync', formData,config).then((res) => {
          this.data = res.data;
          this.baseInforRuleForm.licenceCodeFileName = this.data.fileName;
          if(this.baseInforRuleForm.licenceCodeFileName){
            this.deleteLicTxt="删除"
          }else{
            this.deleteLicTxt=""
          }
          this.baseInforRuleForm.licenceCodeFileUrl = this.data.fileUrl;
          this.baseInforRuleForm.licenceCodeFileKey = this.data.fileKey;
          this.showLienceFlag = true;
          this.$refs['perfectionForm'].validate((valid) => {});
        }).catch((err) => {
          console.log(err)
        })
      },
      tirggerOrganizationCodeFile(event){
        if(this.baseInforRuleForm.organizationCodeFileUrl!=''){
          this.$message({
                message: "您已上传附件，若您需要更新附件，请先删除原附件",
                type: 'error'
          });
          return false;
        }
        let file = event.target.files[0];
        let fileName = String(file.name);
        let fileSize = file.size;
        var AllImgExt=".jpg|.jpeg|.png|.pdf|";
        var extName = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
        if(AllImgExt.indexOf(extName+"|")==-1){
          this.$message({
                message: "仅支持JPG、JPEG、PNG、PDF格式",
                type: 'error'
          });
          return false;
        }
        if(fileSize/1024/1024 >10){
          this.$message({
                message: "上传文件不得超过10M",
                type: 'error'
          });
          return false;
        }
        this.baseInforRuleForm.upfile = event.target.files; // (利用console.log输出看结构就知道如何处理档案资料)
        let formData = new FormData();
        formData.append('upfile', file);
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        this.$axios.post('/onelink.mdata.main.api/upload/uploadSync', formData,config).then((res) => {
          this.data = res.data;
          this.baseInforRuleForm.organizationCodeFileName = this.data.fileName;
          this.baseInforRuleForm.organizationCodeFileUrl = this.data.fileUrl;
        if(this.baseInforRuleForm.organizationCodeFileName){
          this.deleteOrgTxt='删除';
        }else{
          this.deleteOrgTxt='';
        }

          this.baseInforRuleForm.organizationCodeFileKey = this.data.fileKey;
          this.showOrganizationFlag = true;
          this.$refs['perfectionForm'].validate((valid) => {});
        }).catch((err) => {
          console.log(err)
        })
      },
      tirggerTaxCodeFile(event){
        if(this.baseInforRuleForm.taxCodeFileUrl!=''){
          this.$message({
                message: "您已上传附件，若您需要更新附件，请先删除原附件",
                type: 'error'
          });
          return false;
        }
        let file = event.target.files[0];
        let fileName = String(file.name);
        let fileSize = file.size;
        var AllImgExt=".jpg|.jpeg|.png|.pdf|";
        var extName = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
        if(AllImgExt.indexOf(extName+"|")==-1){
          this.$message({
                message: "仅支持JPG、JPEG、PNG、PDF格式",
                type: 'error'
          });
          return false;
        }
        if(fileSize/1024/1024 >10){
          this.$message({
                message: "上传文件不得超过10M",
                type: 'error'
          });
          return false;
        }
        this.baseInforRuleForm.upfile = event.target.files; // (利用console.log输出看结构就知道如何处理档案资料)
        let formData = new FormData();
        formData.append('upfile', file);
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        this.$axios.post('/onelink.mdata.main.api/upload/uploadSync', formData,config).then((res) => {
          this.data = res.data;
          this.baseInforRuleForm.taxCodeFileName = this.data.fileName;
          if(this.baseInforRuleForm.taxCodeFileName){
            this.deleteTaxTxt="删除"
          }else{
            this.deleteTaxTxt=""
          }
          this.baseInforRuleForm.taxCodeFileUrl = this.data.fileUrl;
          this.baseInforRuleForm.taxCodeFileKey = this.data.fileKey;
          this.showTaxFlag = true;
          this.$refs['perfectionForm'].validate((valid) => {});
        }).catch((err) => {
          console.log(err)
        })
      },
      tirggerBussinessChangeFile(event){
        if(this.baseInforRuleForm.bussinessChangeFileUrl!=''){
          this.$message({
                message: "您已上传附件，若您需要更新附件，请先删除原附件",
                type: 'error'
          });
          return false;
        }
        let file = event.target.files[0];
        let fileName = String(file.name);
        let fileSize = file.size;
        var AllImgExt=".jpg|.jpeg|.png|.pdf|";
        var extName = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
        if(AllImgExt.indexOf(extName+"|")==-1){
          this.$message({
            message: "仅支持JPG、JPEG、PNG、PDF格式",
            type: 'error'
          });
          return false;
        }
        if(fileSize/1024/1024 >10){
          this.$message({
            message: "上传文件不得超过10M",
            type: 'error'
          });
          return false;
        }
        this.baseInforRuleForm.upfile = event.target.files; // (利用console.log输出看结构就知道如何处理档案资料)
        let formData = new FormData();
        formData.append('upfile', file);
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        this.$axios.post('/onelink.mdata.main.api/upload/uploadSync', formData,config).then((res) => {
          this.data = res.data;
          this.baseInforRuleForm.bussinessChangeFileUrl = this.data.fileUrl;
          this.baseInforRuleForm.bussinessChangeFileName = this.data.fileName;
          this.baseInforRuleForm.bussinessChangeFileKey = this.data.fileKey;
          this.showBussinessFlag = true;
          this.$refs['perfectionForm'].validate((valid) => {});
        }).catch((err) => {
          console.log(err)
        })
      },
      viewAttachment(url){
        window.location.href=url;
      },
      deleteThreeLienceCodeFile(){
        this.baseInforRuleForm.threeLicenceCodeFileName = '';
        this.showThreeLienceFlag=false;
        this.baseInforRuleForm.threeLicenceCodeFileUrl = '';
        this.baseInforRuleForm.threeLicenceCodeFileKey = '';
        // this.$refs.threeLicenceCodeFile.value= '';
        this.baseInforRuleForm.threeLicenceCode = this.baseInforRuleForm.threeLicenceCode.trim();
        this.$refs['perfectionForm'].validate((valid) => {});
      },
      deleteLienceCodeFile(){
        this.baseInforRuleForm.licenceCodeFileName = '';
        this.deleteLicTxt="";
        this.baseInforRuleForm.licenceCodeFileUrl = '';
        this.baseInforRuleForm.licenceCodeFileKey = '';
        this.showLienceFlag = false;
        this.$refs.licenceCodeFile.value= '';
        this.$refs['perfectionForm'].validate((valid) => {});
      },
      deleteOrganizationCodeFile(){
        this.baseInforRuleForm.organizationCodeFileName = '';
        this.deleteOrgTxt='';
        this.baseInforRuleForm.organizationCodeFileUrl = '';
        this.baseInforRuleForm.organizationCodeFileKey = '';
        this.showOrganizationFlag = false;
        this.$refs.organizationCodeFile.value= '';
        this.$refs['perfectionForm'].validate((valid) => {});
      },
      deleteTaxCodeFile(){
        this.baseInforRuleForm.taxCodeFileName = '';
        this.deleteTaxTxt="";
        this.baseInforRuleForm.taxCodeFileUrl = '';
        this.baseInforRuleForm.taxCodeFileKey = '';
        this.showTaxFlag = false;
        this.$refs.taxCodeFile.value= '';
        this.$refs['perfectionForm'].validate((valid) => {});
      },
      deleteBussinessChangeFile(){
        this.baseInforRuleForm.bussinessChangeFileName = '';
        this.baseInforRuleForm.bussinessChangeFileUrl = '';
        this.baseInforRuleForm.bussinessChangeFileKey = '';
        this.showBussinessFlag = false;
        this.$refs.bussinessChangeFile.value= '';
        this.$refs['perfectionForm'].validate((valid) => {});
      },
      //      成立时间营业期限校验
      changeFoundDate(val){
        this.$refs['perfectionForm'].validate((valid) => {});
      },
      changeBussinessDate(val){
        this.$refs['perfectionForm'].validate((valid) => {});
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/supplierPerfection/index.vue